import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Listbox } from '@headlessui/react';

import { S_Check } from 'hosman-material';

export const ListboxOptions = ({ options, listHeight }) => {
  return (
    <Listbox.Options
      className={`z-50 relative md:absolute w-full border border-white rounded-2xl ring-1 ring-ih-neutral ring-opacity-5 focus:outline-none sm:text-sm overflow-scroll mt-0 md:mt-2 ${listHeight} scrollbar-hide`}
    >
      {options.map((option) => {
        return (
          <Listbox.Option as={Fragment} key={option.id} value={option}>
            {({ active, selected }) => {
              return (
                <li
                  onClick={(e) => e.stopPropagation()}
                  onTouchStart={(e) => e.stopPropagation()}
                  onTouchEnd={(e) => e.stopPropagation()}
                  className={`${
                    active && !selected
                      ? 'bg-opacity-100'
                      : ''
                  } text-white bg-ih-neutral-50/80 hover:bg-ih-neutral-50/90 bg-opacity-90 backdrop-blur cursor-pointer select-none relative py-3 px-3 border-b border-b-white last:border-b-0 first:rounded-t-2xl last:rounded-b-2xl`}
                >
                  <div className='flex items-center text-white'>
                    <p
                      className={`${
                        selected ? 'font-semibold' : ''
                      } ml-3 truncate`}
                    >
                      {selected && (
                        <FontAwesomeIcon
                          icon={S_Check}
                          className='font-semibold mr-2'
                        />
                      )}
                      <span className='whitespace-nowrap'>
                        {option.name.charAt(0).toUpperCase() +
                          option.name.slice(1)}
                      </span>
                    </p>
                  </div>
                </li>
              );
            }}
          </Listbox.Option>
        );
      })}
    </Listbox.Options>
  );
};

ListboxOptions.propTypes = {
  options: PropTypes.array.isRequired,
  listHeight: PropTypes.string,
};
